import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, ArrowRight, Shield, Phone, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import RehabContactForm from '../components/RehabContactForm';
import { massageTherapyContent, clinicInfo } from '../mock';

const MassageTherapy = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-gray-50 to-white py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-[#000053] mb-6">
              {massageTherapyContent.title}
            </h1>
            <p className="text-xl text-[#36454F] mb-8">
              {massageTherapyContent.subtitle}
            </p>
            <Link to="/book">
              <Button size="lg" className="bg-[#006D73] text-white hover:bg-[#005a5f] transition-all">
                Book a Session
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Description Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <p className="text-lg text-gray-700 leading-relaxed mb-12">
              {massageTherapyContent.description}
            </p>

            {/* Services Grid */}
            <div className="bg-gray-50 rounded-lg p-8">
              <h2 className="text-2xl font-bold text-[#000053] mb-8 text-center">Massage Services</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {massageTherapyContent.services.map((service, index) => (
                  <div key={index} className="flex items-start space-x-3">
                    <CheckCircle className="h-6 w-6 text-[#006D73] flex-shrink-0 mt-1" />
                    <span className="text-gray-700">{service}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Insurance Section */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto space-y-6">
            <Card className="border-2 border-[#006D73]">
              <CardContent className="p-8">
                <div className="flex items-start space-x-4">
                  <Shield className="h-8 w-8 text-[#006D73] flex-shrink-0" />
                  <div>
                    <h3 className="text-xl font-bold text-[#000053] mb-3">Insurance & Payment</h3>
                    <p className="text-gray-700">{massageTherapyContent.insurance}</p>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Contact Info */}
            <Card className="border-2 border-[#006D73]">
              <CardContent className="p-8">
                <h3 className="text-xl font-bold text-[#000053] mb-6">Contact Massage Therapy</h3>
                <div className="space-y-4">
                  <div className="flex items-center space-x-4">
                    <Phone className="h-6 w-6 text-[#006D73] flex-shrink-0" />
                    <div>
                      <p className="text-sm text-gray-600 font-medium">Phone</p>
                      <a href={`tel:${clinicInfo.rehabPhone}`} className="text-[#006D73] hover:underline text-lg font-semibold">
                        {clinicInfo.rehabPhone}
                      </a>
                    </div>
                  </div>
                  <div className="flex items-center space-x-4">
                    <Mail className="h-6 w-6 text-[#006D73] flex-shrink-0" />
                    <div>
                      <p className="text-sm text-gray-600 font-medium">Email</p>
                      <a href={`mailto:${clinicInfo.rehabEmail}`} className="text-[#006D73] hover:underline text-lg font-semibold">
                        {clinicInfo.rehabEmail}
                      </a>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>

            {/* Contact Form */}
            <RehabContactForm serviceName="Massage Therapy" />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-[#000053]">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-white mb-6">
              Relax, Restore, and Heal
            </h2>
            <p className="text-gray-300 mb-8">
              Experience the therapeutic benefits of professional massage therapy tailored to your needs.
            </p>
            <Link to="/book">
              <Button size="lg" className="bg-[#006D73] text-white hover:bg-[#005a5f] transition-all">
                Book Your Massage Today
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MassageTherapy;